// extracted by mini-css-extract-plugin
export default {"socialElem":"SocialsModal_socialElem__gF5qh","icon":"SocialsModal_icon__NXMsi","name":"SocialsModal_name__Wrz3n"};